import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orderDetailData: undefined,
  orderDetailSearch: [],
  orderSearchType:""
}

export const orderDetailSlice = createSlice({
  name: 'orderDetail',
  initialState,
  reducers: {
    setOrderNum: (state, orderNum) => {
      state.orderNum = orderNum;
    },
    setOrderDetailData: (state, orderDetail) => {
      state.orderDetailData = orderDetail
      console.log(state.orderDetailData.payload);
    },
    setOrderDetailSearch: (state, orderDetailSearch) => {
      state.orderDetailSearch = orderDetailSearch
      console.log(state.orderDetailSearch.payload);
    },
    setOrderSearchType: (state, orderSearchType) => {
      state.orderSearchType = orderSearchType;
    },

    purge: (state) => {
      state = initialState;
    }
  }
})

// Action creators are generated for each case reducer function
export const { setOrderNum, setOrderDetailData, setOrderDetailSearch, setOrderSearchType } = orderDetailSlice.actions;

export default orderDetailSlice.reducer;